import React from 'react';

import { FloorGameCrypto, FloorGameTierLabel } from '@pkg/types/floorGame';
import { nextTierValue } from '@pkg/utils/floorGame';

import { type TickProps, TicksMeter } from './components';

export interface FloorGameTicksProps {
    ticks?: TickProps[];
    tier?: FloorGameTierLabel;
    currency?: FloorGameCrypto;
    loading?: boolean;
    highlightFirstAvailable?: boolean;
}

export function FloorGameTicks({
    ticks = [],
    tier = FloorGameTierLabel.Tier1,
    currency = FloorGameCrypto.Ethereum,
    loading = false,
    highlightFirstAvailable = false,
}: FloorGameTicksProps) {
    const firstAvailableTick = ticks.find(({ pocketCount, active }) => !pocketCount && !active);

    // We currently suppress any `highlight` prop in favour of `highlightFirstAvailable`.
    const ticksMarkup = ticks.map(({ id, thumbnail, pocketCount, status, active, onAction }, index) => {
        const highlight = highlightFirstAvailable && id === firstAvailableTick?.id;

        return (
            <TicksMeter.Bar.Tick
                key={`ExampleBasic-Item-${index}`}
                id={id}
                thumbnail={thumbnail}
                pocketCount={pocketCount}
                status={status}
                active={active}
                highlight={highlight}
                onAction={onAction}
            />
        );
    });

    const segmentMarkup = loading ? (
        <TicksMeter.Skeleton />
    ) : (
        <TicksMeter.Segment>
            <TicksMeter.Bar>{ticksMarkup}</TicksMeter.Bar>
            <TicksMeter.Milestone currency={currency} price={nextTierValue(tier)} />
        </TicksMeter.Segment>
    );

    return <TicksMeter>{segmentMarkup}</TicksMeter>;
}
